"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const safeGet_1 = __importDefault(require("./safeGet"));
const tabSizes = {
    large: {
        height: "60px",
        fontSize: "2em"
    },
    medium: { height: "40px", fontSize: "1em" },
    small: { height: "30px", fontSize: "1em" }
};
exports.defaultTabBarStyle = {
    fontFamily: "sans-serif",
    barColor: "#8c7ae6",
    headerTextColor: "#fff",
    selectedHeaderTextColor: "#e6d5ec",
    alignHeader: "center",
    showInkBar: true,
    inkBarColor: "white",
    activeInkBarColor: "#82589F",
    size: "medium",
    tabPosition: "top",
    justifyTabs: "space-evenly"
};
exports.TabPane = styled_1.default.div `
  background-color: ${({ styleProps }) => safeGet_1.default(styleProps, "barColor", exports.defaultTabBarStyle.barColor)};
  height: ${({ styleProps }) => tabSizes[safeGet_1.default(styleProps, "size", exports.defaultTabBarStyle.size)].height};
  font-size: ${({ styleProps }) => tabSizes[safeGet_1.default(styleProps, "size", exports.defaultTabBarStyle.size)].fontSize};
  border-bottom: ${({ styleProps }) => safeGet_1.default(styleProps, "showInkBar", true)
    ? `${safeGet_1.default(styleProps, "inkBarColor", exports.defaultTabBarStyle.inkBarColor)} solid 1px`
    : "none"};
  ${({ tabBarCSS }) => tabBarCSS};
`;
exports.ViewPane = styled_1.default.div `
  height: 100%;
`;
exports.TabsList = styled_1.default.section `
  width: ${tabGroupProps => safeGet_1.default(tabGroupProps, "styleProps.width", "inherit")};
  display: flex;
  height: inherit;
  text-align: center;
`;
exports.TabGroupContainer = styled_1.default.div `
  overflow-x: hidden;
  overflow-y: hidden;
  user-select: none;
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: column;
  flex-flow: ${({ styleProps }) => styleProps.tabPosition === "bottom" ? "column-reverse" : "column"};
`;
exports.TabItem = styled_1.default.section `
  color: ${({ isSelected, styleProps }) => isSelected
    ? safeGet_1.default(styleProps, "selectedHeaderTextColor", exports.defaultTabBarStyle.selectedHeaderTextColor)
    : safeGet_1.default(styleProps, "headerTextColor", exports.defaultTabBarStyle.headerTextColor)};
  font-family: ${({ styleProps }) => safeGet_1.default(styleProps, "fontFamily", exports.defaultTabBarStyle.fontFamily)};
  width: ${({ width, styleProps }) => safeGet_1.default(styleProps, "justifyTabs", exports.defaultTabBarStyle.justifyTabs) ===
    "space-evenly"
    ? `${width}%`
    : "inherit"};
  height: inherit;
  padding: ${({ styleProps }) => safeGet_1.default(styleProps, "justifyTabs", exports.defaultTabBarStyle.justifyTabs) ===
    "space-evenly"
    ? `0`
    : " 0 20px"};

  cursor: pointer;
  line-height: ${({ styleProps }) => tabSizes[styleProps.size || exports.defaultTabBarStyle.size].height};
  text-align: ${({ styleProps }) => styleProps.alignHeader || exports.defaultTabBarStyle.alignHeader};
  ${({ tabItemCSS }) => tabItemCSS}
`;
exports.TabSelector = styled_1.default.hr `
  margin: -2px 0px 0px 0px;

  width: ${props => `${100 / props.tabCount}%`};
  border: ${({ styleProps }) => safeGet_1.default(styleProps, "showInkBar", true)
    ? `${safeGet_1.default(styleProps, "activeInkBarColor", exports.defaultTabBarStyle.activeInkBarColor)} solid 1px`
    : "none"};
  margin-left: ${({ selectedTab, tabCount }) => `${(100 / tabCount) * selectedTab}%`};
  transition: 0.1s ease-in-out;
  /* display:none; */
`;
/* margin-left: ${props =>
    `${(props.selectedTab / props.tabCount) * 100}%`}; */
